<template>
	<div class="c-modal-block-view">
		<Modal v-model="options.active" @input="closeModal" :closable="true">
			<nav class="c-modal-block-view__prev" v-if="prevId" @click="onPrev">
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM10.2929 15.7071C10.6834 16.0976 11.3166 16.0976 11.7071 15.7071C12.0976 15.3166 12.0976 14.6834 11.7071 14.2929L10.4142 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H10.4142L11.7071 9.70711C12.0976 9.31658 12.0976 8.68342 11.7071 8.29289C11.3166 7.90237 10.6834 7.90237 10.2929 8.29289L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L10.2929 15.7071Z"
						fill="currentColor"
					/>
				</svg>
			</nav>
			<nav class="c-modal-block-view__next" v-if="nextId" @click="onNext">
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.7071 8.29289C13.3166 7.90237 12.6834 7.90237 12.2929 8.29289C11.9024 8.68342 11.9024 9.31658 12.2929 9.70711L13.5858 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H13.5858L12.2929 14.2929C11.9024 14.6834 11.9024 15.3166 12.2929 15.7071C12.6834 16.0976 13.3166 16.0976 13.7071 15.7071L16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L13.7071 8.29289Z"
						fill="currentColor"
					/>
				</svg>
			</nav>
			<BlockView
				v-if="ad"
				:latestAd="ad"
				@onSubmit="onSubmit"
				@afterDelete="afterDelete"
			></BlockView>
			<div class="c-spinner" v-if="processing"></div>
			<article v-if="error" class="c-modal-block-view__article article-text-lg">
				<p>Ad couldn't be loaded.</p>
			</article>
		</Modal>
	</div>
</template>

<script>
import Modal from './index.vue';

import { parseISO, format } from 'date-fns';

import BlockView from '@swipekit/components/block-view';

import api from '@swipekit/lib/api';

export default {
	components: {
		Modal,
		BlockView,
	},

	data: function () {
		return {
			lock: false,
			error: false,
			options: {
				name: 'modal-block-view',
				active: false,
			},
			ad: null,
			forceRender: true,
			processing: false,
		};
	},

	props: {
		standalone: {
			type: Boolean,
			default: false,
		},
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		viewId: function () {
			this.error = false;
			if (this.viewId) {
				this.options.active = true;
				this.loadAd();
				this.lock = true;
				setTimeout(() => {
					this.lock = false;
				}, 500);
			} else {
				this.options.active = false;
			}
		},
		block: function () {
			this.forceRender = false;
			this.$nextTick(() => {
				this.forceRender = true;
			});
		},
	},

	computed: {
		sourceUrl: function () {
			let block = this.ad.block;

			if (block.source && typeof block.source === 'string') {
				return block.source;
			}

			return null;
		},
		viewCache: function () {
			return this.$store.getters['ads/viewCache'];
		},
		createdAt: function () {
			let createdAt = this.block.createdAt;
			let date = parseISO(createdAt);
			let str = format(date, `do MMM yy`);
			return str;
		},

		viewId: function () {
			return this.$store.getters['ads/viewId'];
		},

		isInViewCache: function () {
			let viewId = this.viewId;
			if (!viewId) {
				return;
			}
			let isInViewCache = false;
			const viewCache = this.viewCache;
			for (let i = 0; i < viewCache.length; i++) {
				const a = viewCache[i];
				if (a.id === viewId) {
					isInViewCache = true;
					break;
				}
			}

			return isInViewCache;
		},

		nextId: function () {
			if (!this.isInViewCache) {
				return;
			}
			if (this.viewCache.length < 2) {
				return;
			}
			let viewId = this.viewId;
			let index = null;
			let viewCache = this.viewCache;
			for (let i = 0; i < viewCache.length; i++) {
				const a = viewCache[i];
				if (a.id === viewId) {
					index = i;
					break;
				}
			}
			if (index === null) {
				return;
			}
			if (viewCache[index + 1]) {
				//console.log(`next - normal ${viewCache[index + 1].id}`);
				return viewCache[index + 1].id;
			} else {
				//console.log(`next - reverse ${viewCache[0].id}`);
				return viewCache[0].id;
			}
		},

		prevId: function () {
			if (!this.isInViewCache) {
				return;
			}
			if (this.viewCache.length < 2) {
				return;
			}
			let viewId = this.viewId;
			let index = null;
			let viewCache = this.viewCache;
			for (let i = 0; i < viewCache.length; i++) {
				const a = viewCache[i];
				if (a.id === viewId) {
					index = i;
					break;
				}
			}
			if (index === null) {
				return;
			}
			if (viewCache[index - 1]) {
				//console.log(`prev - normal ${viewCache[index - 1].id}`);
				return viewCache[index - 1].id;
			} else {
				//console.log(`prev - reverse ${viewCache[viewCache.length - 1].id}`);
				return viewCache[viewCache.length - 1].id;
			}
		},
	},

	methods: {
		onPrev: function () {
			this.$store.dispatch('ads/setView', this.prevId);
		},
		onNext: function () {
			this.$store.dispatch('ads/setView', this.nextId);
		},
		loadAd: async function () {
			this.ad = null;
			this.processing = true;

			const adId = this.viewId;

			if (this.viewCache) {
				let temp = null;
				for (let i = 0; i < this.viewCache.length; i++) {
					const a = this.viewCache[i];
					if (a.id === adId) {
						temp = a;
						break;
					}
				}
				if (temp) {
					this.ad = temp;
					this.processing = false;
					return;
				}
			}

			let response = null;

			if (this.standalone) {
				response = await api.api.getOne(adId);
			} else {
				response = await api.ads.getOne(adId);
			}

			if (response) {
				this.error = false;
				this.ad = response;
			} else {
				this.error = true;
			}
			this.processing = false;
		},
		onSubmit: function () {
			this.options.active = false;
		},
		activate: function () {
			this.options.active = true;
		},
		closeModal: function () {
			if (this.lock) {
				return;
			}
			this.$store.dispatch('ads/setView', null);
		},
		afterDelete: function () {
			this.closeModal();
		},
	},

	mounted: function () {
		//this.options.active = true;
	},
};
</script>

<style lang="scss">
.c-modal-block-view {
	.modal__content > nav {
		position: absolute;
		left: calc(-3rem - 32px);
		top: calc(50% - 64px);
		width: 64px;
		height: 64px;
		color: var(--color-button-font);
		cursor: pointer;
		transition: all 80ms ease-out;
		user-select: none;

		svg {
			width: 100%;
			height: 100%;
		}

		&:hover,
		&:active {
			transform: scale(1.1);
		}

		&.c-modal-block-view__next {
			left: auto;
			right: calc(-3rem - 32px);
		}
	}

	.vfm__overlay {
		background-color: hsla(var(--s), 35%, 7%, 0.75) !important;

		&.non-closable {
		}
	}
	.modal-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		overflow-y: auto;
		padding: 0;
	}

	.modal-content {
		width: 1200px;
		height: 980px;
		max-height: 100%;
		margin: 0;

		//overflow: hidden;;
	}

	.modal__title {
		padding: 0;
	}

	.modal__content {
		padding: 0;
		height: 100%;
		border-radius: 10px !important;
		background-color: var(--color-bg-2);

		> .c-spinner {
			position: absolute;
			top: calc(50% - 24px);
			left: calc(50% - 24px);
			width: 48px;
			height: 48px;
			border-width: 4px;
			border-color: #000;
			border-bottom-color: transparent;
		}
	}

	&__article {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	@media screen and (max-width: 1400px) {
		.modal-content {
			height: 92%;
			width: calc(100% - 192px);
		}
	}

	@media screen and (max-width: 996px) {
		.modal__content {
			> nav {
				display: none;
			}
		}
		.modal-content {
			width: 100%;
			height: calc(100% - 50px);
			margin-top: 50px;
			border-radius: 0;

			> svg {
				top: -42px;
				color: #fff;
			}
		}
		.modal-container {
			display: block;
		}
	}

	@media screen and (min-width: 1800px) {
		.modal-content {
			width: 1440px;
			height: 1200px;
		}
	}
}
</style>
